let defaultTimezone = 'UTC';

export const setDefaultTimezone = (tz: string) => {
  defaultTimezone = tz;
};

export { defaultTimezone };
